<template>
  <el-dialog id="dialogServer" :title="serverLabel" :visible="visible" @close="onClose">
    <el-form id="formServer" label-position="right" label-width="150px">
      <el-form-item :label="serverLabel">
        <dvr-servers-select
          v-model="newIdServer"
          :id-media-core="idMediaCore"
          :id-proxy-server="idProxyServer"
          :is-for-rrtsp="isRrtsp"
        />
      </el-form-item>
      <el-form-item label="Принудительно">
        <el-switch
          v-model="force"
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button id="closeServer" @click="onClose">Отменить</el-button>
      <el-button id="submitServer" :loading="loading" type="primary" @click="onSave">{{ confirmButtonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import DvrServersSelect from "@/components/Server/feature/DvrServersSelect";
import { MEDIA_CORE } from "@/core/helpers/const";

export default {
  name: "DvrServerDialog",
  components: { DvrServersSelect },
  props: {
    idServer: {
      type: Number,
      default: null,
    },
    idMediaCore: {
      type: Number,
      default: null,
    },
    idProxyServer: {
      type: Number,
      default: null,
    },
    isRrtsp: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    confirmButtonText: {
      type: String,
      default: "Сохранить",
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      newIdServer: null,
      force: 0,
    };
  },
  computed: {
    serverLabel() {
      if (this.idMediaCore === MEDIA_CORE.VK3) return "ArchCore";
      if (this.idMediaCore === MEDIA_CORE.VK2) return "DVR-сервер";
      return "Медиа-сервер";
    },
  },
  watch: {
    idServer: {
      immediate: true,
      handler(idServer) {
        this.newIdServer = idServer;
      },
    },
  },
  methods: {
    onSave() {
      this.$emit("save", this.newIdServer, this.force);
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>
